import { FormState } from "react-hook-form";
import { EnumCadastroTipo, KeyValueModel } from "../../../../../model";
import { AutocompletePessoas } from "../../../../components/autocompletes/autocomplete-pessoas";
import { DefaultCard } from '../../../../components/cards/components';
import { TextFieldSaurus } from "../../../../components/controles/inputs";
import { SelectSaurus } from "../../../../components/controles/selects/select-saurus/select-saurus";
import { RelatorioMensalVendaModel } from "../models/relatorio-models";
import { useStyles } from "./relatorio-mensal-venda-styles";

interface RMVFormProps {
  listaMeses: KeyValueModel[];
  formState: FormState<RelatorioMensalVendaModel>;
  register: any;
  formRMV: RelatorioMensalVendaModel;
  errorValidationfarmaceutico: boolean;
  setErrorValidationfarmaceutico: React.Dispatch<React.SetStateAction<boolean>>;
  setFormRMV: React.Dispatch<React.SetStateAction<RelatorioMensalVendaModel>>;
}

export const RelatorioMensalVendaForm = ({ listaMeses, formState, register, formRMV, setFormRMV, errorValidationfarmaceutico, setErrorValidationfarmaceutico }: RMVFormProps) => {
  const styles = useStyles();
  const { errors } = formState;

  return (
    <div className={`flex-column h-100 w-100 ${styles.innerFormContainer}`}>
      <DefaultCard className={styles.card}>
        <div className={`w-100 ${styles.inputContainer}`}>
          <AutocompletePessoas label="Farmacêutico"
            name="farmaceutico"
            size="medium"
            tipo={EnumCadastroTipo.TODOS}
            onChange={(e: any) => setFormRMV({ ...formRMV, farmaceutico: e?.value?.id })}
            error={Boolean(errorValidationfarmaceutico && !formRMV.farmaceutico)}
            helperText={
              errorValidationfarmaceutico && !formRMV.farmaceutico
                ? "O Farmacêutico é obrigatório!"
                : undefined
            }
            onBlur={() => {
              if (!formRMV.farmaceutico)
                setErrorValidationfarmaceutico(true);
            }}
          />
        </div>

        <div className={`flex-row w-100 ${styles.inputContainer}`}>
          <div className={styles.dataPeriodoContainer}>
            <div className="w-50">
              <SelectSaurus label="Mês"
                conteudo={listaMeses}
                className={`h-100 w-100 ${styles.inputStyle}`}
                variant="outlined"
                size="medium"
                allowSubmit
                required
                error={Boolean(errors.mes && !formRMV.mes)}
                helperText={
                  errors.mes && !formRMV.mes
                    ? errors.mes?.message
                    : undefined
                }
                {...register('mes', {
                  onChange: (e: any) => setFormRMV({ ...formRMV, mes: e.target.value })
                })}
              />
            </div>

            <div className="w-50">
              <TextFieldSaurus
                className={`h-100 w-100 ${styles.inputStyle}`}
                labelCustom="Ano"
                value={formRMV.ano}
                name="ano"
                required
                tipo="NUMERO"
                size="medium"
                variant="outlined"
                inputProps={{ maxLength: 4 }}
                error={Boolean(errors.ano && !formRMV.ano)}
                helperText={
                  errors.ano && !formRMV.ano
                    ? errors.ano?.message
                    : undefined
                }
                {...register('ano', {
                  onChange: (e: any) => setFormRMV({ ...formRMV, ano: !isNaN(Number(e.target.value)) ? Number(e.target.value) : 0 })
                })}
              />
            </div>
          </div>
        </div>
      </DefaultCard>
    </div>
  );
} 